import { render, staticRenderFns } from "./MailConfirmationExpired.vue?vue&type=template&id=4c6ade02&scoped=true"
import script from "./MailConfirmationExpired.vue?vue&type=script&lang=js"
export * from "./MailConfirmationExpired.vue?vue&type=script&lang=js"
import style0 from "./MailConfirmationExpired.vue?vue&type=style&index=0&id=4c6ade02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ade02",
  null
  
)

export default component.exports